export default "__VITE_ASSET__BSAnhMGt__"